module.exports = __webpack_public_path__ + "04_long_black.2cad182b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_long_black.png
// module id = JbBw
// module chunks = 0